import { Box, Button, Typography } from "@mui/material";
import Logo from "../../assets/logo.png";
import { useTranslation } from "react-i18next";
//import { useContext } from "react";
//import { UserContext } from "../../context/UserContext";

export default function AccountDeletion({ drawerWidth }) {
	const { t } = useTranslation();
	const { user } = { user: null }; //useContext(UserContext);

	return (
		<Box
			sx={{
				...{
					flexGrow: 1,
					bgcolor: "background.default",
					p: {
						xs: user || drawerWidth ? 3 : 0,
						sm: 3,
					},
					margin: {
						xs: 4, //user ? 4 : 0,
						sm: 4,
					},
					minHeight: "100%",
				},
				...(drawerWidth
					? {
							width: {
								xs: "calc(100% - 0px)",
								sm: "calc(100vw - " + (drawerWidth - 64) + "px)",
							},
							marginLeft: { xs: "32px", sm: "160px" },
							marginTop: "96px",
					  }
					: {
							marginTop: user || drawerWidth ? "96px" : "40px",
					  }),
			}}
		>
			<Box>
				<Box
					sx={{
						flexDirection: "column",
						justifyContent: "flex-start",
						alignItems: "flex-start",
						padding: 4,
						marginTop: 4,
						gap: 2,
						display: "flex",
						background: "white",
					}}
				>
					<img
						src={Logo}
						alt="logo"
						style={{ width: 90, cursor: "pointer" }}
						onClick={() => {
							window.location.href = window.location.origin;
						}}
					/>
					<Typography>{t("general.deleteAccount")}</Typography>
					<Button
						variant="contained"
						sx={{ width: "auto" }}
						onClick={() => {
							window.location.href = "mailto:info@applaby.com";
						}}
					>
						{t("general.sendEmail")}
					</Button>
				</Box>
				{/*user ? (
					<Box
						sx={{
							flexDirection: "column",
							justifyContent: "flex-start",
							alignItems: "flex-start",
							padding: 4,
							marginTop: 4,
							gap: 2,
							display: "flex",
							background: "white",
						}}
					>
						<Typography>{t("general.deleteAccount")}</Typography>
						<Button
							variant="contained"
							sx={{ width: "auto" }}
							onClick={() => {
								window.location.href = "mailto:info@applaby.com";
							}}
						>
							{t("general.sendEmail")}
						</Button>
					</Box>
				) : (
					<Box
						sx={{
							flexDirection: "column",
							justifyContent: "flex-start",
							alignItems: "flex-start",
							padding: {
								xs: 0,
								sm: 4,
							},
							gap: 2,
							display: "flex",
							background: "white",
						}}
					>
						<img
							src={Logo}
							alt="logo"
							style={{ width: 90, cursor: "pointer", margin: 20 }}
							onClick={() => {
								window.location.href = window.location.origin;
							}}
						/>
						<iframe
							src="https://docs.google.com/forms/d/e/1FAIpQLSfAWuuGvDHC-Lqp6s-r_hHOVkzraTL3-HM77cqtimCEgG0Hcg/viewform?embedded=true"
							width="100%"
							style={{ minHeight: 740 }}
							frameborder="0"
							marginheight="0"
							marginwidth="0"
						>
							Loading…
						</iframe>
					</Box>
					)*/}
			</Box>
		</Box>
	);
}
